import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCreditType implements BaseEnumType {
  private static allValues: EnumCreditType[] = []; // make sure this is top-most
  
  public static none = new EnumCreditType(0, "None", "enum_credit_type_none");
  public static creditNoDutyReclaim = new EnumCreditType(1, "CreditNoDutyReclaim", "enum_credit_type_credit_no_duty_reclaim");
  public static dutyOnlyReclaim = new EnumCreditType(2, "DutyOnlyReclaim", "enum_credit_type_duty_only_reclaim");
  public static creditWithDutyReclaim = new EnumCreditType(3, "CreditWithDutyReclaim", "enum_credit_type_credit_with_duty_reclaim");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCreditType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumCreditType.none; }
  public isCreditNoDutyReclaim() { return this === EnumCreditType.creditNoDutyReclaim; }
  public isDutyOnlyReclaim() { return this === EnumCreditType.dutyOnlyReclaim; }
  public isCreditWithDutyReclaim() { return this === EnumCreditType.creditWithDutyReclaim; }

  public static getValues(): readonly EnumCreditType[] {
    return EnumCreditType.allValues;
  }

  public static getValuesExcept0(): readonly EnumCreditType[] {
    return EnumCreditType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCreditType {
    const found = EnumCreditType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCreditType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCreditType): EnumCreditType {
    const found = name ? EnumCreditType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCreditType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCreditType>): boolean {
    return this.key === other?.key;
  }
}